import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrismicUtils } from '@segurosvoluntarios_vel/commons-services';
import { BaseEstadoPagoComponent } from 'src/app/pago/containers/estado-pago/base-estado/base-estado-pago.component';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';

@Component({
  selector: 'app-rechazado',
  templateUrl: './rechazado.component.html',
  styleUrls: [
    './rechazado.component.scss',
    '../base-estado/base-estado-pago.component.scss',
  ],
})
export class RechazadoComponent extends BaseEstadoPagoComponent
  implements OnInit {
  @Input() pago: Pago;
  @Input() contenido: ContenidoDeEstadoDePago;
  @Input() tenant: string;
  constructor(private router: Router, public prismicUtils: PrismicUtils) {
    super(prismicUtils);
  }
  ngOnInit(): void {
    this.inicializar(this.pago, this.contenido, this.tenant);
  }

  redirectToPago() {
    this.router.navigate([`/${this.tenant}/${this.pago.idPago}`]);
  }
}
